import React, { useState } from 'react'
import TabButton from './TabButton'
import ActiveBadges from './ActiveBadges'
import DeletedBadges from './DeletedBadges'
import { connect } from 'react-redux'
import {  getBadges } from '../../store/actions/badge'
import { useEffect } from 'react'


function AllBadges({ badge, getBadges }) {
  const { badges } = badge
  console.log(badges);
  const [allBadges,setAllBadges] = useState(badges)
  
  const [formObj, setFormObj] = useState({
    state: 'idle',
  })
  useEffect(() => {
    getBadges(formObj, setFormObj)
    
  }, [getBadges])
  return (
    <div id='AllBadges'>
      <h4 className='ps-2 ps-md-2 mt-4 title'>All Badges</h4>
      <div className='ps-2 ps-md-2 mt-4'>
        <nav>
          <div className='nav nav-tabs' id='nav-tab' role='tablist'>
            <TabButton name='available' label='Active Badges' active />
            <TabButton name='deleted' label='Deleted Badges' />
          </div>
        </nav>
        <div className='tab-content' id='nav-tabContent'>
          <div
            className='tab-pane fade show active'
            id='nav-available'
            role='tabpanel'
            aria-labelledby='nav-available-tab'>
            <ActiveBadges badges={allBadges} />
          </div>
          <div className='tab-pane fade' id='nav-deleted' role='tabpanel' aria-labelledby='nav-deleted-tab'>
            <DeletedBadges badges={allBadges} />
          </div>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = ({ badge }) => ({ badge })

export default connect(mapStateToProps, { getBadges })(AllBadges)
